import appointments from "../appointments";

function normalizeEndpoint(endpoint) {
  const value = String(endpoint || "").trim();

  if (!value) {
    return "";
  }

  return value.replace(/^\/+/, "").replace(/^api\/?/i, "");
}

export function buildApiUrl(endpoint) {
  const baseUrl = String(appointments.baseURL || "").trim().replace(/\/+$/, "");
  const normalizedEndpoint = normalizeEndpoint(endpoint);

  if (!baseUrl) {
    return `/api/${normalizedEndpoint}`;
  }

  return `${baseUrl}/${normalizedEndpoint}`;
}

export async function postJson(endpoint, body = {}, token = null) {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(buildApiUrl(endpoint), {
    method: "POST",
    headers,
    body: JSON.stringify(body || {}),
  });

  const payload = await response.json().catch(() => ({}));

  return { response, payload };
}
